<template>
  <div class="delivery-address">
    <rCenterHeader></rCenterHeader>
    <div class="address-list common-flex common-flex-wrap" :style="{ minHeight: 'calc(100vh - 140px)'}">
      <rChooseAddress @addAddress="addAddress"></rChooseAddress>
      <rAddress
        v-for="(item, index) in addressList"
        :key="index"
        :config="item"
        @detail="detail"
        @del="del"
        @edit="edit"
        @setDefault="setDefault"
      ></rAddress>
    </div>
    <rAddNewAddress
      :type="type"
      @saveConfirm="saveConfirm"
      @changeType="changeType"
      :addressId="addressId"
      :addNew="addNew"
      @handlerAdd="handlerAdd"
    ></rAddNewAddress>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import rChooseAddress from "../../components/r-chooseAddress";
import rAddress from "../../components/r-address";
import rAddNewAddress from "../../components/r-add-new-address";
import rCenterHeader from "../../components/r-center-header";
export default {
  name: "deliveryAddress",
  components: {
    rChooseAddress,
    rAddress,
    rAddNewAddress,
    rCenterHeader,
  },
  data() {
    return {
      addNew: false,
      addressList: [],
      // 类型 0普通新增  1查看  2编辑
      type: 0,
      addressId: "",
      
    };
  },
  mounted() {
    this.getAddressList();
  },
  methods: {
    ...mapActions([
      "addressListAction", //地址列表
      // "selectOneAddressAction",//地址详情
      "setDefaultAction", //设置默认
      "delAddressAction", //删除地址
    ]),

    // 设置默认地址
    setDefault(e) {
      this.setDefaultAction({ id: e.id }).then((res) => {
        if (res.code == 0) {
          this.getAddressList();
        }
      });
    },
    // 编辑
    edit(e) {
      this.addressId = e.id;
      this.addNew = true;
      this.type = 2;
    },
    // 详情直接编辑
    changeType() {
      this.type = 2;
    },
    // 详情
    detail(e) {
      this.addressId = e.id;
      this.addNew = true;
      this.type = 1;
    },
    // 重新请求列表接口
    saveConfirm() {
      this.addNew = false;
      this.getAddressList();
    },
    // 删除
    del(e) {
      this.$Modal.confirm({
        title: this.$t("delMsg.tips"),
        content: this.$t("delMsg.content"),
        okText: this.$t("user.determine"),
        cancelText: this.$t("user.cancel"),
        onOk: () => {
          this.delAddressAction({ ids: [e.id] }).then((res) => {
            if (res.code == 0) {
              this.getAddressList();
            }
          });
        },
      });
    },
    handlerAdd(e) {
      this.addressId = ''
      this.addNew = false;
    },
    // 地址列表
    getAddressList() {
      this.addressListAction().then((res) => {
        console.log("res", res);
        this.addressList = res.data;
      });
    },
    addAddress() {
      this.addNew = true;
      this.addressId = ''
      this.type = 0;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.delivery-address {
  width: 1440px;
  margin: 0 auto;
  .delivery-address-box {
    width: 1420px;
    margin: 10px 10px 0;
    background: #fff;
    .delivery-header {
      height: 70px;
      border-bottom: 1px solid #f0f0f0;
      padding: 26px 30px 25px;
      .delivery-o-name {
        opacity: 1;
        font-size: 16px;
        font-family: Roboto, Roboto-Regular;
        font-weight: 400;
        text-align: left;
        color: #000000;
        line-height: 19px;
      }
      .delivery-t-name {
        opacity: 1;
        font-size: 16px;
        font-family: Roboto, Roboto-Bold;
        font-weight: 700;
        text-align: left;
        color: #000000;
        line-height: 19px;
        margin-left: 10px;
      }
    }
  }
  .address-list {
    padding: 20px;
    background: #fff;
    width: 1420px;
    margin: 0 auto;
    > div {
      margin: 0 10px 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/deliveryAddress/deliveryAddress.vue